<template>
  <el-dialog v-model="visible" title="添加到 AI 标签反馈清单" width="560px" destroy-on-close>
    <div v-if="image" class="feedback-context">
      <el-image :src="resourceUrl(image.thumbnail || image.resource)" fit="cover" class="feedback-image" />
      <div>
        <div>图片 ID：{{ image.id }}</div>
        <div class="feedback-tip">系统会保存 AI 建议、提交时的标签快照、模型和词表版本。尚未手动修正时，标签快照仍可能是错误建议，请在说明中写明正确标签。</div>
      </div>
    </div>
    <el-form label-width="90px">
      <el-form-item label="问题类型" required>
        <el-select v-model="form.issue_type" style="width: 100%">
          <el-option v-for="item in issueTypes" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="问题说明">
        <el-input v-model="form.note" type="textarea" :rows="4" maxlength="1000" show-word-limit
                  placeholder="例如：戴尖顶巫师帽，应识别为女巫。说明可选填。" />
      </el-form-item>
    </el-form>
    <el-alert title="反馈仅用于后续分析，不会自动修改正式标签、词表或 AI 规则。" type="info" :closable="false" show-icon />
    <template #footer>
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="submit">添加到反馈清单</el-button>
    </template>
  </el-dialog>
</template>

<script>
import axios from 'ts-axios-new';
import {ElMessage} from 'element-plus';

const CDN_URL = import.meta.env.VITE_CDN_URL || 'https://jigsaw-cdn.plutodesk.com';

export default {
  name: 'AiTagFeedbackDialog',
  props: {
    modelValue: Boolean,
    image: Object,
  },
  emits: ['update:modelValue', 'submitted'],
  data() {
    return {
      submitting: false,
      form: {issue_type: 'wrong_tag', note: ''},
      issueTypes: [
        {value: 'wrong_tag', label: '标签错了'},
        {value: 'missing_tag', label: '缺少标签'},
        {value: 'extra_tag', label: '多余标签'},
        {value: 'wrong_category', label: '分类错误'},
        {value: 'vocabulary_missing', label: '词表没有合适标签'},
        {value: 'other', label: '其他'},
      ],
    };
  },
  computed: {
    visible: {
      get() { return this.modelValue; },
      set(value) { this.$emit('update:modelValue', value); },
    },
  },
  watch: {
    modelValue(value) {
      if (value) this.form = {issue_type: 'wrong_tag', note: ''};
    },
  },
  methods: {
    resourceUrl(resource) {
      if (!resource || /^https?:\/\//.test(resource)) return resource || '';
      return `${CDN_URL.replace(/\/$/, '')}/${resource}`;
    },
    errorMessage(error) {
      return error?.response?.data?.status?.msg || error?.response?.data?.message || error?.message || '提交失败';
    },
    submit() {
      if (!this.image?.id) {
        ElMessage.warning('图片信息不完整，请刷新后重试');
        return;
      }
      this.submitting = true;
      axios.post('/cms/v1/ai/tag/feedback', {
        result_id: this.image.ai_tag_result_id,
        image_id: this.image.id,
        issue_type: this.form.issue_type,
        note: this.form.note.trim(),
      }).then(res => {
        ElMessage.success('已添加到 AI 标签反馈清单');
        this.$emit('submitted', res.data.data);
        this.visible = false;
      }).catch(error => {
        ElMessage.error(this.errorMessage(error));
      }).finally(() => {
        this.submitting = false;
      });
    },
  },
};
</script>

<style scoped>
.feedback-context {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
}

.feedback-image {
  width: 88px;
  height: 88px;
  border-radius: 6px;
  flex: none;
}

.feedback-tip {
  color: var(--el-text-color-secondary);
  font-size: 13px;
  line-height: 1.6;
  margin-top: 8px;
}
</style>
